module.exports = __webpack_public_path__ + "img/b137166.png";